import { withJsonFormsControlProps } from "@jsonforms/react";
import { CustomRendererProps } from "../types";
import { EventSupportManagement as Management } from "layouts/aplicacoes/Events/components/EventSupportManagement";

function EventSupportManagement({data}:CustomRendererProps<any>){ return data?.id?<Management eventId={Number(data.id)}/>:null; }
export default withJsonFormsControlProps(EventSupportManagement);
